<template>
  <v-row no-gutters>
    <!-- 左邊出現的待編輯題目清單 -->
    <v-col :cols="leftColSpan" class="pt-7 px-5 Q02010_left">
      <!-- 查詢、送出元件 -->
      <v-row no-gutters>
        <v-col :cols="4">
          <v-select
            v-model="questSysId"
            :items="surveys"
            item-text="questTitle"
            item-value="questSysId"
            menu-props="auto"
            :label="!questSysId || questSysId === null ? '尚未選擇問卷' : '已選擇問卷'"
            outlined
            @change="onQuestMChange()"
          ></v-select>
        </v-col>
        <v-col :cols="4">
          <v-btn @click="query" large class="ml-2 mt-1" color="primary">查詢</v-btn>
          <v-btn @click="submit" large class="ml-2 mt-1" color="primary">送出</v-btn>
        </v-col>
      </v-row>

      <!-- 警示文字 -->
      <v-alert
        v-for="(alert, idx) in alerts"
        :key="idx"
        v-model="alert.show"
        :type="alert.type"
        dense
        dismissible
      >
        <!-- <template slot="close">
          <v-progress-circular :value="alert.value" :size="20" color="primary">
          </v-progress-circular>
        </template> -->
        {{ alert.msg }}
      </v-alert>

      <v-divider class="mb-2"></v-divider>
      <draggable
        class="dragArea list-group fill-height"
        :list="ques.list"
        @update="quesCalculateSerial"
        group="ques"
      >
        <!-- isEdit 顯示題號以及刪除切換switch更改題目內容 -->
        <!-- get pageType info -->
        <Ques
          v-for="(ques, idx) in ques.list"
          :key="ques.key"
          :ques="ques"
          :isEdit="false"
          :pageType="pageType"
          class="mb-2"
          @quesDel="quesDel(idx)"
        />
      </draggable>
    </v-col>
    <!-- 取消排序頁面的新增題型功能 -->
    <!-- 右邊可拖拉的題型 -->
    <!-- <v-col :cols="rightColSpan" class="px-1 py-4 Q02010_right" v-show="showleft">
      <draggable
        class="dragArea list-group"
        :list="ques_template"
        :group="{ name: 'ques', pull: 'clone', put: false }"
        :clone="quesClone"
      >
        <v-hover
          v-for="(qtype, idx) in ques_template"
          :key="idx"
          v-slot:default="{ hover }"
        >
          <v-card class="Q02010_right_card py-1 px-2 ma-1" :elevation="hover ? 12 : 2">
            <v-icon class="Q02010_right_card_icon" @click="quesAdd(qtype)"
              >mdi-plus-thick</v-icon
            >
            {{ qtype.text }}
          </v-card>
        </v-hover>
      </draggable>
    </v-col> -->
  </v-row>
</template>

<script>
import draggable from 'vuedraggable'
import Ques from '../components/QuesRouter'
import QType from '../store/QType'
export default {
  created() {
    this.ques_template = Object.values(this.$store.state.QType)
  },
  async mounted() {
    let url = this.$store.state.api + '/Q02010/GetM'
    // window.console.log(url)
    let res = await this.axios(url)
    this.surveys = res.data.questMList
  },
  data() {
    return {
      questSysId: null, // 正在查詢的 questSysId
      ques: {
        key: 0, // 紀錄 ques 因加入、查詢而不斷獲得遞增的 key (用於 v-for) 當前值
        list: [],
      },
      alerts: [], // 警告隊列
      ques_template: [], // 問卷問題的範本
      surveys: [], // 可選的問卷清單
      hasDoQuery: false, // 是否已查詢過
    }
  },
  components: {
    Ques,
    draggable,
  },
  methods: {
    quesDel(idx) {
      this.ques.list.splice(idx, 1)
      this.quesCalculateSerial()
    },
    onQuestMChange() {
      this.hasDoQuery = false
      //this.query()
    },
    // 取得要複製的題目
    quesClone(qtype) {
      let tmp = Object.assign({ ...qtype.template })
      // 如果是單選題、矩陣題，需要深度複製陣列
      if (qtype.name === QType.MATRIX.name) {
        tmp.subQues = qtype.template.subQues.map((x) => Object.assign({}, { ...x }))
        tmp.items = qtype.template.items.slice()
      }
      if (qtype.name === QType.CHOICE.name || qtype.name === QType.CHOICE_MULTIPLE.name) {
        tmp.items = qtype.template.items.slice()
        tmp.files = qtype.template.files.slice()
        tmp.fileRoutes = qtype.template.fileRoutes.slice()
      }
      tmp.questSysId = this.questSysId
      return tmp
    },
    // 取消排序頁面的新增題型功能
    // 增加題目時的動作
    // async quesAdd(qtype) {
    //   if (!this.questSysId) {
    //     this.addAlert('info', '無法在沒有問卷主檔資料時新增問題')
    //     return
    //   }
    //   let tmp = this.quesClone(qtype) // 取得題目
    //   tmp.key = this.QuesKeysAdd()
    //   this.ques.list.push(tmp)
    //   this.quesCalculateSerial() // 更新題目內紀載的題目順序
    //   this.addAlert(
    //     'success',
    //     '已新增：' + qtype.text + '，題號：' + this.ques.list.length
    //   )
    // },
    async query() {
      let url = this.$store.state.api + '/Q02010/query'

      if (!this.questSysId || this.questSysId === null) {
        this.addAlert('warning', '查詢時沒有提供問卷主檔Id')
        return
      }
      let res = await this.axios(url, {
        params: { questSysId: parseInt(this.questSysId) },
      })
      window.console.log(res.data)
      this.ques.list = res.data.details.map((d) => {
        // 找到該問題的 template
        let template = Object.values(this.$store.state.QType).find(
          (q) => q.template.questItemType === d.questItemType
        ).template
        // 將後端得到的題目合併到 template 上推到問題清單
        return Object.assign(
          { ...template },
          { ...d },
          {
            key: this.QuesKeysAdd(), // 重新計算 key
            files: [], // 確保查詢之後不會殘留 local 選擇的檔案
          }
        )
      })
      // get pageType info
      this.pageType = res.data.pageType
      this.questDNext = res.data.questDNext
      window.console.log('questDNext', this.questDNext)

      let i = 0
      for (let index = 0; index < this.ques.list.length; index++) {
        const element = this.ques.list[index]
        if (element.questItemType === 'choice') {
          element.colus.splice(index, 1) //拿掉同一題的選項
          //加入nextCol紀錄
          element.nextCol = [null] 
          for (let index2 = 0; index2 < element.items.length - 1; index2++) {
            element.nextCol.push(null)
          }
          if (
            i < this.questDNext.length &&
            element.enName === this.questDNext[i].enName
          ) {
            element.skipItem = this.questDNext[i].isUse //add skipItem value
            for (let index2 = 0; index2 < element.items.length; index2++) {
              if (
                i < this.questDNext.length &&
                element.enName === this.questDNext[i].enName &&
                this.questDNext[i].itemOrderId === index2
              ) {
                element.nextCol[index2] = this.questDNext[i].nextCol
                i++
              }
            }
          }
        }
      }

      this.ques.list.forEach((element) => {
        element.colus.unshift({ cnName: '--請選擇題目--', enName: null })
      })

      //讓新加入的skipItem與nextCol可以動態變動
      this.ques = JSON.parse(JSON.stringify(this.ques))

      window.console.log('ques', this.ques)

      this.addAlert('success', '查詢完成')
      this.hasDoQuery = true
    },
    async submit() {
      try {
        if (!this.hasDoQuery)
          throw { type: 'warning', msg: '請先查詢題目，修改後才可送出。' }
        // 確認有問卷主檔
        if (!this.questSysId) throw { type: 'warning', msg: '送出時沒有提供問卷主檔Id。' }

        let quesList = this.ques.list
        let fd = new FormData()
        // 指定題目順序、抽出要上傳的檔案
        quesList.forEach(function (q, idx) {
          q.serial = idx + 1 // 重新賦予順序 (應該不用，但保險起見)
          // 抽取要上傳的圖片
          if (q.files != null) {
            let quesSerial = q.serial.toString().padStart(3, '0') // Key prefix
            // 處理問題中的檔案
            q.files.forEach((file, idx) => {
              if (file != null) {
                let itemSerial = (idx + 1).toString().padStart(3, '0') // Key suffix
                // 把檔案附加到 formData
                fd.append(quesSerial + '_' + itemSerial, file)
              }
            })
          }

          // 把 data/img 從 fileRoutes 當中過濾掉
          if (q.fileRoutes != null) {
            q.fileRoutes.forEach((e) => {
              if (e.startsWith('data')) {
                e = ''
              }
            })
          }
          // 把空的 item 去除(單選、多選)
          if (q.items) {
            q.items = q.items.filter((x) => x.length > 0)
          }
          // 把空的 nextCol 去除(單選)
          // if(q.nextCol) {
          //   q.nextCol = q.nextCol.filter((x) => x.length > 0)
          // }
        })

        // stringfy ques.list then append as details
        window.console.log('將要提交的 quesList:')
        window.console.log(quesList)
        fd.append('details', JSON.stringify(quesList))
        window.console.log('將要提交的 quesList 已完成序列化')
        fd.append('questSysId', this.questSysId)

        // 進行 以 ajax 提交
        let url = this.$store.state.api + '/Q02010/submit'
        // window.console.log(fd)
        let res = await this.axios.post(url, fd)
        switch (res.data.resultCode) {
          case '10':
            window.console.log(res.data.quesList)
            res.data.quesList.forEach((q, idx) => {
              window.console.log(q)
              Object.assign(quesList[idx], {
                id: q.rowId,
                fileRoutes: q.fileRoutes,
                files: [],
                enName: q.enName,
              })
            })
            // window.console.log(quesList)
            this.addAlert('success', '送出完成')
            break
          case '01':
            throw { type: 'error', msg: res.data.error }
          default:
            let msg = '無法解析自後端獲得的狀態碼: ' + res.data.resultCode
            throw { type: 'error', msg }
        }
      } catch (e) {
        this.addAlert(e.type, e.msg)
      }
    },
    addAlert(type, msg, timeout) {
      // 建立一個 alert 物件並推到 alerts
      let alert = { msg: msg, type: type, show: true, value: 0 }
      this.alerts.push(alert)

      // 檢查 timeout 參數，如果沒有就設為 1.5 秒
      if (timeout === undefined || timeout === null) {
        timeout = 1500
      }
      // 安排 alert 消失的時間
      setTimeout(function () {
        alert.show = false
      }, timeout)
    },
    QuesKeysAdd() {
      this.ques.key += 1
      return this.ques.key
    },
    // 重新分配 serial
    quesCalculateSerial() {
      this.ques.list.forEach((q, idx) => {
        q.serial = idx + 1
      })
    },
  },
  computed: {
    // 是否顯示右邊問題卡片作為拖拉源頭
    showleft() {
      // 'xs': 0,
      // 'sm': 600px,
      // 'md': 960px,
      // 'lg': 1280px - 16px,
      // 'xl': 1920px - 16px
      return this.$vuetify.breakpoint.mdAndUp
    },
    // 左邊欄位所佔的 cols (1-12)
    leftColSpan() {
      return this.showleft ? 10 : 12
    },
    // 右邊欄位所佔的 cols (1-12)
    rightColSpan() {
      return 2
    },
  },
}
</script>

<style lang="scss" scoped>
.Q02010_right_card {
  cursor: grabbing;
}
.Q02010_right_card_icon {
  cursor: pointer;
}
.Q02010_left {
  height: 100vh;
  overflow-y: scroll;
}
.Q02010_right {
  height: 100vh;
  overflow-y: scroll;
}
/* Hide scrollbars */
::-webkit-scrollbar {
  display: none;
}
</style>
